import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { IConfiguration } from "@/models/admin/configuration/configuration.types"
import { Configuration } from "@/models/admin/configuration/configuration"
import { GetConfigurationsQuery } from "@/api/hasura/generated/graphql"
import dayjs from "dayjs"
import { safeDayjs } from "@/helpers/dateHelper"

type ConfigurationRaw = GetConfigurationsQuery["configuration"][0]

export const ConfigurationParser: IParser<IConfiguration, ConfigurationRaw> = {
  toDomain(data) {
    try {
      return new Configuration(
        data.id,
        data.name,
        data.value,
        data.editable ?? false,
        dayjs(data.from_dt),
        safeDayjs(data.to_dt),
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
